import Vue from 'vue';
import options from "../../util/map/mapOptions";
import "mapbox-gl/dist/mapbox-gl.css";
var _map;
export default Vue.extend({
    name: "gridMap",
    props: ['mapId'],
    data: function () {
        return {};
    },
    mounted: function () {
        var _options = options;
        _options.container = this.mapId;
        _map = new mapboxgl.Map(_options);
        _map.on("load", function () {
        });
    },
    methods: {},
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/iview-loader??ref--0-1!./src/sfc/map/gridMap.vue
// module id = null
// module chunks = 